


















































import { Vue, Component, Prop } from "../vue-ext";

import {
    transportDeviationService,
} from "@/services";

import {
    TransportDeviation,
    TransportDeviationEvent,
} from "@/models";

@Component
export default class TaskViewDeviations extends Vue {
    @Prop() taskId!: string;

    deviations: null | TransportDeviation[] = null;
    imageDialog = { visible: false, url: null };

    async mounted() {
        this.deviations = (
            await transportDeviationService.searchDeviations({
                taskId: [this.taskId]
            })
        ).items;
    }

    generateEventAuditString(event: TransportDeviationEvent): string {
        return (event.user ? event.user.email + " / " : "") +
            this.$d(new Date(event.timestamp), "full");
    }
}
